var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSavedCommands(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-1fe0cb7a-d592-48d9-ad23-53dbfc821af4",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m26.427,29.249H5.573c-1.512,0-2.742-1.23-2.742-2.742v-6.556c0-1.512,1.23-2.742,2.742-2.742h20.855c1.512,0,2.742,1.23,2.742,2.742v6.556c0,1.512-1.23,2.742-2.742,2.742Zm-20.597-3h20.339v-6.041H5.83v6.041Z",
    style: {
      fill: "#e7e7e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.427,14.792H5.573c-1.512,0-2.742-1.23-2.742-2.742v-6.556c0-1.512,1.23-2.742,2.742-2.742h20.855c1.512,0,2.742,1.23,2.742,2.742v6.556c0,1.512-1.23,2.742-2.742,2.742Zm-20.597-3h20.339v-6.041H5.83v6.041Z",
    style: {
      fill: "#e7e7e7"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedCommands);
export default __webpack_public_path__ + "static/media/SavedCommands.c2889741cf9ce02fdac8dc1278adb3f4.svg";
export { ForwardRef as ReactComponent };